import { Injectable } from '@angular/core';
import { createClient, Entry } from 'contentful';

import { config } from '../../environments/environment';
import { PageLoaderService } from './page-loader.service';

@Injectable()
export class ContentfulService {
  private client = createClient({
    space: config.contentful.spaceId,
    accessToken: config.contentful.token,
    environment: config.contentful.environment,
    host: config.contentful.host
  });

  constructor(private pageLoaderService: PageLoaderService) {}

  getSearchResults(query?: object): Promise<any> {
    this.pageLoaderService.addPageLoader(true);
    return this.client
      .getEntries(
        Object.assign(
          {
            content_type: 'page',
            select: 'fields.searchResultTitle,fields.searchableTags,fields.url,fields.searchableText',
            limit: 500
          },
          query
        )
      )
      .then((res) => {
        this.pageLoaderService.addPageLoader(false);
        return res.items;
      })
      .catch((err) => console.error(err));
  }

  getPageContentResponse(query?: object): Promise<any> {
    this.pageLoaderService.addPageLoader(true);
    return this.client
      .getEntries(
        Object.assign(
          {
            content_type: 'page'
          },
          query
        )
      )
      .then((res) => {
        this.pageLoaderService.addPageLoader(false);
        return res;
      })
      .catch((err) => console.error(err));
  }

  getRevisionNoticePageResponse(query?: object): Promise<any> {
    this.pageLoaderService.addPageLoader(true);
    return this.client
      .getEntries(
        Object.assign(
          {
            content_type: 'ndcProductUpdateNotification'
          },
          query
        )
      )
      .then((res) => {
        this.pageLoaderService.addPageLoader(false);
        return res.items;
      })
      .catch((err) => console.error(err));
  }
  getIagRevisionNoticePageResponse(query?: object): Promise<any> {
    this.pageLoaderService.addPageLoader(true);
    return this.client
      .getEntries(
        Object.assign(
          {
            content_type: 'iagProductUpdateNotification'
          },
          query
        )
      )
      .then((res) => {
        this.pageLoaderService.addPageLoader(false);
        return res.items;
      })
      .catch((err) => console.error(err));
  }

  getPageVersions(query?: object): Promise<any> {
    this.pageLoaderService.addPageLoader(true);
    return this.client
      .getEntries(
        Object.assign(
          {
            content_type: 'page'
          },
          query
        )
      )
      .then((res) => {
        this.pageLoaderService.addPageLoader(false);
        return res.items;
      })
      .catch((err) => console.error(err));
  }

  getPageContentWithEntries(query?: object): Promise<Entry<any>[]> {
    this.pageLoaderService.addPageLoader(true);
    return this.client
      .getEntries(
        Object.assign(
          {
            content_type: 'page'
          },
          query
        )
      )
      .then((res: any) => {
        this.pageLoaderService.addPageLoader(false);
        return res && res.includes && res.includes.Entry;
      })
      .catch((err) => console.error(err));
  }

  getPageContentWithAssets(query?: object): Promise<any> {
    this.pageLoaderService.addPageLoader(true);
    return this.client
      .getEntries(
        Object.assign(
          {
            content_type: 'page'
          },
          query
        )
      )
      .then((res) => {
        this.pageLoaderService.addPageLoader(false);
        return res.includes;
      })
      .catch((err) => console.error(err));
  }

  getPageContentWithItems(query?: object): Promise<any> {
    this.pageLoaderService.addPageLoader(true);
    return this.client
      .getEntries(
        Object.assign(
          {
            content_type: 'page'
          },
          query
        )
      )
      .then((res) => {
        this.pageLoaderService.addPageLoader(false);
        return res.items;
      })
      .catch((err) => console.error(err));
  }

  getMenuContentWithItems(query?: object): Promise<any> {
    this.pageLoaderService.addPageLoader(true);
    return this.client
      .getEntries(
        Object.assign(
          {
            content_type: 'menu'
          },
          query
        )
      )
      .then((res) => {
        this.pageLoaderService.addPageLoader(false);
        return res.items;
      })
      .catch((err) => console.error(err));
  }
}
